import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
  Paper
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// Фирменные цвета из исходного компонента
const themeColors = {
  primary: '#af3831',
  primaryLight: '#c44940',
  primaryDark: '#963029',
  hover: 'rgba(175, 56, 49, 0.04)',
  focus: 'rgba(175, 56, 49, 0.12)'
};

const AcquiringPage = () => {
  // Упрощенный компонент, без отображения деталей транзакции
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Получаем статус из URL-параметра
    const params = new URLSearchParams(window.location.search);
    const paymentStatus = params.get("status");
    
    setStatus(paymentStatus);
    
    // Имитация загрузки для лучшего UX
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  // Определяем содержимое карточки в зависимости от статуса
  const renderContent = () => {
    if (loading) {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 4 }}>
          <CircularProgress sx={{ color: themeColors.primary, mb: 2 }} />
          <Typography variant="h6">Обрабатываем результат платежа...</Typography>
        </Box>
      );
    }

    if (status === "success") {
      return (
        <>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 2 }}>
            <Typography variant="body1" align="center" sx={{ mb: 4 }}>
              Благодарим за оплату. Ваш тариф активирован.
            </Typography>
            
            <Button
              variant="contained"
              href="https://apod-lab.tech/"
              fullWidth
              sx={{ 
                bgcolor: themeColors.primary, 
                '&:hover': { bgcolor: themeColors.primaryLight },
                '&:active': { bgcolor: themeColors.primaryDark },
                maxWidth: "sm" // При желании можно ограничить максимальную ширину
              }}
            >
              Перейти в панель управления
            </Button>
          </Box>
        </>
      );
    }
    
    if (status === "fail") {
      return (
        <>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 2 }}>
            <Typography variant="body1" align="center" sx={{ mb: 4 }}>
              К сожалению, при обработке платежа произошла ошибка. 
              Пожалуйста, обратитесь в техническую поддержку.
            </Typography>
            
            <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 2 }}>
              <Button
                variant="contained"
                href="https://t.me/APOD_lab"
                fullWidth
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  bgcolor: themeColors.primary, 
                  '&:hover': { bgcolor: themeColors.primaryLight },
                  '&:active': { bgcolor: themeColors.primaryDark }
                }}
              >
                Написать в поддержку
              </Button>
            </Box>
          </Box>
        </>
      );
    }
    
    // Если статус не определен или некорректен
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 2 }}>
        <Typography variant="body1" align="center" sx={{ mb: 4 }}>
          Пожалуйста, свяжитесь с технической поддержкой.
        </Typography>
        <Button
          variant="contained"
          href="https://t.me/APOD_lab"
          fullWidth
          target="_blank"
          rel="noopener noreferrer"
          sx={{ 
            bgcolor: themeColors.primary, 
            '&:hover': { bgcolor: themeColors.primaryLight },
            '&:active': { bgcolor: themeColors.primaryDark },
            maxWidth: "sm" // Опциональное ограничение максимальной ширины
          }}
        >
          Написать в поддержку
        </Button>
      </Box>
    );
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 500, padding: 3, boxShadow: 3 }}>
        <CardContent>
          {renderContent()}
        </CardContent>
      </Card>
    </Container>
  );
};

export default AcquiringPage;